<template>
  <div :class="type" class="user user-qa-link">
    <div v-if="isInactiveLink" class="link-el">
      <span v-if="avatar" class="user-avatar" :style="{ backgroundImage: `url('${$config.imagesUrl}/avatars/thumb@128_${info.userImage || 'default-avatar.png'}')` }" />
      <span class="name">{{ info.user }}</span>
    </div>

    <nuxt-link
      v-else-if="isLocalLink"
      class="link-el"
      :to="userLink"
    >
      <span v-if="avatar" class="user-avatar" :style="{ backgroundImage: `url('${$config.imagesUrl}/avatars/thumb@128_${info.userImage || 'default-avatar.png'}')` }" />
      <span class="name">{{ info.user }}</span>
    </nuxt-link>

    <a
      v-else
      target="_blank" :rel="$config.project === 'site' ? 'nofollow' : ''"
      :href="`${projectLink}${userLink}`"
      class="link-el"
    >
      <span v-if="avatar" class="user-avatar" :style="{ backgroundImage: `url('${$config.imagesUrl}/avatars/thumb@128_${info.userImage || 'default-avatar.png'}')` }" />
      <span class="name">{{ info.user }}</span>
    </a>
  </div>
</template>

<script>
import qaHubMixin from '../mixins/qa-hub';

export default {
  mixins: [qaHubMixin],
  props: {
    info: { type: Object, required: true },
    type: { type: String, required: false, default: '' },
    avatar: { type: Boolean },
  },
};
</script>

<style lang="scss">
.user.user-qa-link {
  overflow: hidden;
  // margin-right: var(--spacing-16);
  display: flex;
  align-items: center;
  font-size: 12px;

  & + .badge {
    margin-right: auto;

    .user-badge {
      margin-right: var(--spacing-16);
    }
  }

  .link-el {
    color: var(--accent-shade-2);
    font-weight: 600;
    text-decoration-line: underline;
    font-size: 14px;
    display: flex;
    align-items: center;
    overflow: hidden;
    margin-right: var(--spacing-4);
    max-width: 100%;

    .user-avatar {
      flex: 0 0 auto;
    }

    .name {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &:hover {
      cursor: pointer;
      text-decoration-line: underline;
    }
  }

  div.link-el:hover {
    cursor: default;
  }

  span.user-avatar {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    margin-right: 12px;
    display: inline-block;
    background-size: cover;
    background-position: center;
  }

  &.similar {
    .link-el {
      color: var(--accent-shade-2);
      font-weight: 600;
      text-decoration-line: underline;
      font-size: 14px;
      display: flex;
      align-items: center;

      &:hover {
        text-decoration-line: none;
      }
    }

    .user-badge {
      display: none;
    }
  }

  &.question-details {
    .link-el {
      display: flex;
      align-items: center;

      span.user-avatar {
        width: 26px;
        height: 26px;
      }
    }
  }
}

@include bp($bp-mobile) {
  .user.user-qa-link {
    min-width: 0;
    flex-direction: column-reverse;
    align-items: flex-start;

    .badge {
      margin-bottom: var(--spacing-8);
    }

    &.question-details {
      flex-direction: column-reverse;
    }
  }
}

.fa {
  .user.user-qa-link .link-el {
    color: var(--accent);
  }
}
</style>
